export default "__VITE_ASSET__eb50e715__"